import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { UiNodeSpec } from './UiNodeSpec';

export const defaultValUiNodeSpec: UiNodeSpec<'defaultVal'> = {
    requiredSockets: [ 'input', 'output' ],
    cfg: () => ({ id: getUID(), kind: 'defaultVal', disabled: false }),
    controls: () => ({}),
    inputs: nodeCfg => ({
        defaultValue: {
            control: {
                cfg: {
                    kind: 'varValue',
                    nullable: true,
                    label: 'Default',
                },
                nullable: true,
                nodeCfg,
                value: nodeCfg.socketDefaults?.inputs?.defaultValue,
            },
            socket: 'varValue',
        },
        input: { socket: 'varValue', label: 'Input' },
    }),
    kindLabel: 'Default Value',
    nodeCategory: 'variable',
    outputs: () => ({ output: { socket: 'varValue', label: 'Output' } }),
    validator: () => true,
};
